// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserEditView_userProfile__OGb0C {
  margin: auto;
  max-width: 500px;
  padding: 20px;
}

.UserEditView_invisibleLabel__4y\\+PA {
  height: 22px;
}

.UserEditView_invisibleContainer__ljCRX {
  margin-left: 10px;
}

.UserEditView_title__rwKxh {
  margin-top: 40px;
  margin-bottom: 20px;
}

.UserEditView_titleMin__sK7qB {
  margin-top: 40px;
  margin-bottom: 0;
}

.UserEditView_inputContainer__PSthj,
.UserEditView_inputButton__gXUJV {
  min-width: 220px;
  max-width: 220px;
  min-height: 42px;
}
.UserEditView_inputContainer__PSthj input,
.UserEditView_inputButton__gXUJV input {
  text-align: left;
}

.UserEditView_inputButton__gXUJV {
  padding: 10px;
  margin: 10px;
}

.UserEditView_button__ZQ95N {
  min-width: 220px;
  margin: 10px;
}

.UserEditView_buttonContainer__3YOpl {
  padding-top: 20px;
  padding-left: 0;
  padding-right: 20px;
}
@media (min-width: 320px) {
  .UserEditView_buttonContainer__3YOpl {
    padding-left: 20px;
  }
}
@media (min-width: 720px) {
  .UserEditView_buttonContainer__3YOpl {
    padding-left: 0;
  }
}

.UserEditView_avatarContainer__yMbKN {
  text-align: center;
}

.UserEditView_avatar__MJOjL {
  border-radius: 50%;
  width: 144px;
  height: 144px;
  border: 3px solid var(--accent-color);
}

.UserEditView_subtitle__c0ziz {
  margin-top: 0;
  margin-left: 0;
  color: #666;
}

.UserEditView_checkboxContainer__nJ-xb {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/views/UserEditView/UserEditView.module.scss","webpack://./src/_common/scss/_media.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;AAFF;;AAKA;;EAEE,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;AAIE;;EACE,gBAAA;AADJ;;AAKA;EACE,aAAA;EACA,YAAA;AAFF;;AAKA;EACE,gBAAA;EACA,YAAA;AAFF;;AAKA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;AAFF;ACtCI;EDqCJ;IAMI,kBAAA;EADF;AACF;ACnCI;ED6BJ;IAUI,eAAA;EAAF;AACF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;EACA,WAAA;AAAF;;AAGA;EACE,gBAAA;AAAF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_media';\n\n.userProfile {\n  margin: auto;\n  max-width: 500px;\n  padding: 20px;\n}\n\n.invisibleLabel {\n  height: 22px;\n}\n\n.invisibleContainer {\n  margin-left: 10px;\n}\n\n.title {\n  margin-top: 40px;\n  margin-bottom: 20px;\n}\n\n.titleMin {\n  margin-top: 40px;\n  margin-bottom: 0;\n}\n\n.inputContainer,\n.inputButton {\n  min-width: 220px;\n  max-width: 220px;\n  min-height: 42px;\n\n  input {\n    text-align: left;\n  }\n}\n\n.inputButton {\n  padding: 10px;\n  margin: 10px;\n}\n\n.button {\n  min-width: 220px;\n  margin: 10px;\n}\n\n.buttonContainer {\n  padding-top: 20px;\n  padding-left: 0;\n  padding-right: 20px;\n\n  @include media(xss) {\n    padding-left: 20px;\n  }\n\n  @include media(sm) {\n    padding-left: 0;\n  }\n}\n\n.avatarContainer {\n  text-align: center;\n}\n\n.avatar {\n  border-radius: 50%;\n  width: 144px;\n  height: 144px;\n  border: 3px solid $accent;\n}\n\n.subtitle {\n  margin-top: 0;\n  margin-left: 0;\n  color: #666;\n}\n\n.checkboxContainer {\n  margin-top: 10px;\n}\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userProfile": `UserEditView_userProfile__OGb0C`,
	"invisibleLabel": `UserEditView_invisibleLabel__4y+PA`,
	"invisibleContainer": `UserEditView_invisibleContainer__ljCRX`,
	"title": `UserEditView_title__rwKxh`,
	"titleMin": `UserEditView_titleMin__sK7qB`,
	"inputContainer": `UserEditView_inputContainer__PSthj`,
	"inputButton": `UserEditView_inputButton__gXUJV`,
	"button": `UserEditView_button__ZQ95N`,
	"buttonContainer": `UserEditView_buttonContainer__3YOpl`,
	"avatarContainer": `UserEditView_avatarContainer__yMbKN`,
	"avatar": `UserEditView_avatar__MJOjL`,
	"subtitle": `UserEditView_subtitle__c0ziz`,
	"checkboxContainer": `UserEditView_checkboxContainer__nJ-xb`
};
export default ___CSS_LOADER_EXPORT___;
